module.exports = __webpack_public_path__ + "static/media/strawberries.744ffac4.jpg";